import { Component, Input, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StatisticsPngExportService } from 'app/services/statistics-png-export.service';
import { StatisticsExportWidget } from 'app/services/statistics-export.models';

@Component({
  selector: 'statistics-png-download-btn',
  standalone: true,
  imports: [NgIf, TranslateModule],
  templateUrl: './statistics-png-download-btn.component.html',
  styleUrls: ['./statistics-png-download-btn.component.css'],
})
export class StatisticsPngDownloadBtnComponent {
  @Input() widget: StatisticsExportWidget | null = null;

  loading = false;

  private destroyed = false;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public pngExport: StatisticsPngExportService,
    private cdr: ChangeDetectorRef,
  ) {
    this.destroyRef.onDestroy(() => { this.destroyed = true; });
  }

  get isDisabled(): boolean {
    return !this.widget || this.loading || this.pngExport.captureInProgress || !this.pngExport.isTabDataReady();
  }

  async download(): Promise<void> {
    if (this.isDisabled || !this.widget) {
      return;
    }
    this.loading = true;
    try {
      await this.pngExport.downloadWidgetPng(this.widget);
    } catch (err) {
      // download() is invoked from a template click binding, so a rejected
      // promise would surface as an unhandled rejection. Log and swallow here;
      // the spinner is reset in finally.
      console.error('PNG download failed:', err);
    } finally {
      // captureForExport() chains canvas rendering / requestAnimationFrame callbacks
      // that may complete outside Angular's zone; detectChanges() guarantees
      // the spinner clears immediately regardless of zone context.
      // Guard against ViewDestroyedError if the tab was switched mid-capture.
      this.loading = false;
      if (!this.destroyed) {
        this.cdr.detectChanges();
      }
    }
  }
}
